import React from 'react';
import { useTranslation } from 'react-i18next';
import { OuSwitchPromptProps } from './types';
import ConfirmDialog from '10.quickConnect.app/components/shared/LayOut/ConfirmDialog';

/**
 * Popups du contrôle d'UO (portage de OUSwitchPrompt Android) : proposition de changement d'UO courante, refus si
 * l'UO est hors du périmètre de l'utilisateur, ou proposition de suppression d'une inbox hors périmètre.
 * Les data-cy de ConfirmDialog (confirmDialogComponent, -confirm, -cancel, -text) sont ceux que la non-régression
 * utilise pour reconnaître ces popups : ne pas les remplacer
 */
const OuSwitchPrompt = ({ prompt, confirm, refuse }: OuSwitchPromptProps) => {
  const { t } = useTranslation(['common', 'declaration', 'inboxes']);
  if (!prompt) return null;

  switch (prompt.kind) {
    case 'switch':
      return (
        <ConfirmDialog
          open
          close={refuse}
          actionForLabelOne={confirm}
          actionLabelOne={t('qcapp_button_yes', { ns: 'declaration' }).toString()}
          cancelLabel={t('qcapp_dialog_action_cancel', { ns: 'declaration' }).toString()}
          title={t('qcapp_alert_dialog_change_ou').toString()}
          subtitle={prompt.message}
          sendingData={false}
        />
      );
    case 'deleteInbox':
      return (
        <ConfirmDialog
          open
          close={refuse}
          actionForLabelOne={confirm}
          actionLabelOne={t('qcapp_dialog_delete_inbox', { ns: 'inboxes' }).toString()}
          cancelLabel={t('qcapp_dialog_action_cancel', { ns: 'declaration' }).toString()}
          title={t('qcapp_alert_dialog_inbox_ou_unauthorized_title', { ns: 'inboxes' }).toString()}
          subtitle={t('qcapp_alert_dialog_inbox_ou_unauthorized_message', { ns: 'inboxes' }).toString()}
          sendingData={false}
        />
      );
    default:
      return (
        <ConfirmDialog
          open
          close={refuse}
          actionForLabelOne={refuse}
          actionLabelOne={t('qcapp_alert_dialog_ou_out_of_scope_ok').toString()}
          title={t('qcapp_alert_dialog_change_ou').toString()}
          subtitle={t('qcapp_alert_dialog_ou_out_of_scope').toString()}
          sendingData={false}
        />
      );
  }
};

export default OuSwitchPrompt;
